import { create } from "zustand";

type ImagesModalStoreType = {
    isImagesModalOpen: boolean;
    setIsImagesModalOpen: (open: boolean, newPostid?: number) => void;
};

export const useImagesModalStore = create<ImagesModalStoreType>()((set) => ({
    isImagesModalOpen: false,
    setIsImagesModalOpen: (open) => {
        set({
            isImagesModalOpen: open,
        });
    },
}));
